import styled, { css } from 'styled-components'

export const StyledContainerButtonCosts = styled.div`
    ${({ condition }) => css`
        display: grid;
        grid-template-columns: ${condition ? ' 140px 140px' : '140px'};
        grid-gap: 10px;
    `}
`
